import { clsx } from 'clsx';
import { motion } from 'motion/react';
import type { HTMLMotionProps } from 'motion/react';
import React from 'react';
import type { PropsWithChildren, PropsWithoutRef } from 'react';
import type { FlexProps } from '../../components/Flex/Flex';
import { Flex } from '../../components/Flex/Flex';
import { foundations } from '../../styles/foundations.css';
import type { FoundationsVariants } from '../../styles/foundations.css';
import * as styles from './Card.css';

export type CardProps = PropsWithoutRef<
  FoundationsVariants & Omit<FlexProps, 'as'> & Omit<HTMLMotionProps<'button'>, 'type'>
>;

export const Card: React.FC<PropsWithChildren<CardProps>> = ({
  children,
  borderRadius,
  shadow,
  glow,
  onClick,
  className: externalClassName,
  ...props
}) => (
  <Flex
    as={onClick == null ? undefined : motion.button}
    className={clsx(foundations({ borderRadius, shadow, glow }), styles.card, externalClassName)}
    flexDirection="column"
    {...props}
    onClick={onClick}
    type={onClick == null ? undefined : 'button'}
  >
    {children}
  </Flex>
);
